import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import close from "../assets/cancel.svg";
import user from "../assets/user.svg";
// import { LOGOUT } from "../config/helper";
import { logout } from "../actions/auth";
import { toast } from "react-toastify";
// import { Select } from "antd";

const ProfileMenu = ({ setOpen, email, displayEmail, }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userType = localStorage.getItem("user_type") || "";
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  const canManageDelegates = userType !== "delegate_user" || permissions.manage_delegates;
  // const [customers, setCustomers] = useState([
  //   {
  //     "id": "164c84ef-35df-4542-a898-8c2829d7a998",
  //     "name": "Best4Tires GmbH",
  //     "email": "venkat.b@tdiapj.com",
  //     "authentication_token": "c27244fd1df839c8d987",
  //     "region": "other",
  //     "phone": "43 0 463513644",
  //     "region_1": "",
  //     "inco1": "FOB",
  //     "zterm": "Z760",
  //     "zterm_txt": "90 Days After Bill of Lading Date",
  //     "country": "DE",
  //     "inco1_txt": "Free on board",
  //     "kdgrp": "Z5",
  //     "kdgrp_txt": "Europe",
  //     "sap_id": "11000021",
  //     "cart_id": "fdf0111c-8ff1-4184-9f23-85fb1031bec0",
  //     "shipping_addresses": [
  //       {
  //         "id": "dcaace9e-4a6b-46b5-9493-c287b10fa835",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Antwerp",
  //         "address2": null,
  //         "city": "Antwerp Port",
  //         "state": null,
  //         "zip": "1234",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-09-29T08:18:38.967Z",
  //         "updated_at": "2023-09-29T08:18:38.967Z",
  //         "country": "BE",
  //         "sap_id": "11000021",
  //         "sap_ref": "24620",
  //         "kunn2": "12000030",
  //         "partner_fun": null
  //       },
  //       {
  //         "id": "3d2ab338-c303-4e22-afe0-a96453c76b6a",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Rotterdam",
  //         "address2": null,
  //         "city": "Rotterdam Port",
  //         "state": null,
  //         "zip": "5928 LH",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-09-29T08:18:38.967Z",
  //         "updated_at": "2023-09-29T08:18:38.967Z",
  //         "country": "NL",
  //         "sap_id": "11000021",
  //         "sap_ref": "26640",
  //         "kunn2": "12000161",
  //         "partner_fun": null
  //       },
  //       {
  //         "id": "6877aa3f-9eb2-4dbe-9fc4-35a06902a30d",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "",
  //         "address2": null,
  //         "city": "Riga port",
  //         "state": null,
  //         "zip": "1234",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-09-29T08:18:38.967Z",
  //         "updated_at": "2023-09-29T08:18:38.967Z",
  //         "country": "LV",
  //         "sap_id": "11000021",
  //         "sap_ref": "25104",
  //         "kunn2": "12000339",
  //         "partner_fun": null
  //       },
  //       {
  //         "id": "66db21f0-07cc-4048-a807-a8ee72566987",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Naples",
  //         "address2": null,
  //         "city": "Naples",
  //         "state": null,
  //         "zip": "12345",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-09-29T08:18:38.967Z",
  //         "updated_at": "2023-09-29T08:18:38.967Z",
  //         "country": "IT",
  //         "sap_id": "11000021",
  //         "sap_ref": "24621",
  //         "kunn2": "12000031",
  //         "partner_fun": null
  //       },
  //       {
  //         "id": "aa34ebd7-6893-45aa-848a-c5fa429bb7bb",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Hamburg Port",
  //         "address2": null,
  //         "city": "Hamburg",
  //         "state": null,
  //         "zip": "12345",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-09-29T08:18:38.967Z",
  //         "updated_at": "2023-09-29T08:18:38.967Z",
  //         "country": "DE",
  //         "sap_id": "11000021",
  //         "sap_ref": "24693",
  //         "kunn2": "12000074",
  //         "partner_fun": null
  //       },
  //       {
  //         "id": "5717e578-b459-4fd2-bc56-fc2bda215125",
  //         "name": "Best4Tires GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "",
  //         "address2": null,
  //         "city": "Klaipeda port,",
  //         "state": null,
  //         "zip": "56203",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-09-29T08:18:38.967Z",
  //         "updated_at": "2023-09-29T08:18:38.967Z",
  //         "country": "LT",
  //         "sap_id": "11000021",
  //         "sap_ref": "25111",
  //         "kunn2": "12000346",
  //         "partner_fun": null
  //       },
  //       {
  //         "id": "0af25720-d200-479b-ac78-9f7afc97e5bf",
  //         "name": "Best4Tires GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Rathausstraße 52-58",
  //         "address2": null,
  //         "city": "Höhr-Grenzhausen",
  //         "state": null,
  //         "zip": "56203",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:24.229Z",
  //         "updated_at": "2023-10-31T08:18:24.229Z",
  //         "country": "DE",
  //         "sap_id": "11000021",
  //         "sap_ref": "24226",
  //         "kunn2": "11000021",
  //         "partner_fun": "SP"
  //       },
  //       {
  //         "id": "3de4936e-92f5-4615-ac59-21e15e6d3ba2",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Antwerp",
  //         "address2": null,
  //         "city": "Antwerp Port",
  //         "state": null,
  //         "zip": "1234",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:24.229Z",
  //         "updated_at": "2023-10-31T08:18:24.229Z",
  //         "country": "BE",
  //         "sap_id": "11000021",
  //         "sap_ref": "24620",
  //         "kunn2": "12000030",
  //         "partner_fun": "SH"
  //       },
  //       {
  //         "id": "94c7300a-e5a5-466e-bfc2-d65f29b7a6a2",
  //         "name": "Best4Tires GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "",
  //         "address2": null,
  //         "city": "Klaipeda port,",
  //         "state": null,
  //         "zip": "56203",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:24.229Z",
  //         "updated_at": "2023-10-31T08:18:24.229Z",
  //         "country": "LT",
  //         "sap_id": "11000021",
  //         "sap_ref": "25111",
  //         "kunn2": "12000346",
  //         "partner_fun": "SH"
  //       },
  //       {
  //         "id": "24105d41-592e-41e3-8226-59cf0d33fd51",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Hamburg Port",
  //         "address2": null,
  //         "city": "Hamburg",
  //         "state": null,
  //         "zip": "12345",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:24.229Z",
  //         "updated_at": "2023-10-31T08:18:24.229Z",
  //         "country": "DE",
  //         "sap_id": "11000021",
  //         "sap_ref": "24693",
  //         "kunn2": "12000074",
  //         "partner_fun": "SH"
  //       },
  //       {
  //         "id": "f980e981-b6d8-4b16-8a9e-a3e33d346d84",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Rotterdam",
  //         "address2": null,
  //         "city": "Rotterdam Port",
  //         "state": null,
  //         "zip": "5928 LH",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:24.229Z",
  //         "updated_at": "2023-10-31T08:18:24.229Z",
  //         "country": "NL",
  //         "sap_id": "11000021",
  //         "sap_ref": "26640",
  //         "kunn2": "12000161",
  //         "partner_fun": "SH"
  //       },
  //       {
  //         "id": "b4a5b161-6939-42c2-8da2-2c341e8cf75c",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "",
  //         "address2": null,
  //         "city": "Riga port",
  //         "state": null,
  //         "zip": "1234",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:24.229Z",
  //         "updated_at": "2023-10-31T08:18:24.229Z",
  //         "country": "LV",
  //         "sap_id": "11000021",
  //         "sap_ref": "25104",
  //         "kunn2": "12000339",
  //         "partner_fun": "SH"
  //       },
  //       {
  //         "id": "b085fa23-4dae-46bb-b898-e5b4b6af323b",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Naples",
  //         "address2": null,
  //         "city": "Naples",
  //         "state": null,
  //         "zip": "12345",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:24.229Z",
  //         "updated_at": "2023-10-31T08:18:24.229Z",
  //         "country": "IT",
  //         "sap_id": "11000021",
  //         "sap_ref": "24621",
  //         "kunn2": "12000031",
  //         "partner_fun": "SH"
  //       },
  //       {
  //         "id": "5f958f80-d214-4f8b-b225-52edcb84f89b",
  //         "name": "Best4Tires GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Rathausstraße 52-58",
  //         "address2": null,
  //         "city": "Höhr-Grenzhausen",
  //         "state": null,
  //         "zip": "56203",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-03T08:18:17.275Z",
  //         "updated_at": "2023-10-03T08:18:17.275Z",
  //         "country": "DE",
  //         "sap_id": "11000021",
  //         "sap_ref": "24226",
  //         "kunn2": "11000021",
  //         "partner_fun": "BP"
  //       },
  //       {
  //         "id": "5814ecfa-ddac-48cf-b1ff-8b8d259c0e03",
  //         "name": "Best4Tires GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Rathausstraße 52-58",
  //         "address2": null,
  //         "city": "Höhr-Grenzhausen",
  //         "state": null,
  //         "zip": "56203",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-03T08:18:17.276Z",
  //         "updated_at": "2023-10-03T08:18:17.276Z",
  //         "country": "DE",
  //         "sap_id": "11000021",
  //         "sap_ref": "24226",
  //         "kunn2": "11000021",
  //         "partner_fun": "10"
  //       },
  //       {
  //         "id": "1e359b12-694c-4851-bb15-85dcc5e1969f",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Klaipeda Port",
  //         "address2": null,
  //         "city": "Klaipeda",
  //         "state": null,
  //         "zip": "068807",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-09-29T08:18:38.967Z",
  //         "updated_at": "2023-09-29T08:18:38.967Z",
  //         "country": "LT",
  //         "sap_id": "11000021",
  //         "sap_ref": "25726",
  //         "kunn2": "12000032",
  //         "partner_fun": null
  //       },
  //       {
  //         "id": "68a183f7-3e0e-47c7-b13a-e153d3493540",
  //         "name": "Reifen Gundlach GmbH",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "Klaipeda Port",
  //         "address2": null,
  //         "city": "Klaipeda",
  //         "state": null,
  //         "zip": "068807",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:24.229Z",
  //         "updated_at": "2023-10-31T08:18:24.229Z",
  //         "country": "LT",
  //         "sap_id": "11000021",
  //         "sap_ref": "25726",
  //         "kunn2": "12000032",
  //         "partner_fun": "SH"
  //       }
  //     ],
  //     "total_alerts": 0,
  //     "dashboard": [
  //       {
  //         "ShipStatus0": "",
  //         "CompletedQuotation": "2",
  //         "ShipStatus1": "",
  //         "OpenQuotation": "65",
  //         "ShipStatus2": "",
  //         "CompletedSales": "6",
  //         "ShipStatus3": "",
  //         "OpenSales": "12",
  //         "ShipStatus4": "",
  //         "CompletedDelivery": "",
  //         "ShipStatus5": "",
  //         "OpenDelivery": "4",
  //         "ShipStatus6": "1",
  //         "CompletedBilling": "",
  //         "ShipStatus7": "4",
  //         "OpenBilling": "4"
  //       }
  //     ]
  //   },
  //   {
  //     "id": "c384da2c-72a8-4858-9af7-65397f7ce170",
  //     "name": "Gobind Tyres",
  //     "email": "venkat.b@tdiapj.com",
  //     "authentication_token": "400cb2e548ee5c1762b8",
  //     "region": "other",
  //     "phone": "91 22 26051509",
  //     "region_1": "",
  //     "inco1": "FOB",
  //     "zterm": "Z760",
  //     "zterm_txt": "90 Days After Bill of Lading Date",
  //     "country": "IN",
  //     "inco1_txt": "Free on board",
  //     "kdgrp": "Z2",
  //     "kdgrp_txt": "MEA/Latin",
  //     "sap_id": "11000011",
  //     "cart_id": "2561a035-3983-4720-b9c9-5cc4a243c14f",
  //     "shipping_addresses": [
  //       {
  //         "id": "d5391e32-fd96-4041-a3ad-6b1f5ea30d7e",
  //         "name": "Gobind Tyres",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "LAMINGTON ROAD, NR.MINERVA",
  //         "address2": null,
  //         "city": "Mumbai",
  //         "state": null,
  //         "zip": "400007",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-03T08:18:23.008Z",
  //         "updated_at": "2023-10-03T08:18:23.008Z",
  //         "country": "IN",
  //         "sap_id": "11000011",
  //         "sap_ref": "24219",
  //         "kunn2": "11000011",
  //         "partner_fun": "10"
  //       },
  //       {
  //         "id": "31aee6fe-2d3a-4d5c-9292-1abb51767d40",
  //         "name": "Gobind Tyres",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "LAMINGTON ROAD, NR.MINERVA",
  //         "address2": null,
  //         "city": "Mumbai",
  //         "state": null,
  //         "zip": "400007",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-03T08:18:23.008Z",
  //         "updated_at": "2023-10-03T08:18:23.008Z",
  //         "country": "IN",
  //         "sap_id": "11000011",
  //         "sap_ref": "24219",
  //         "kunn2": "11000011",
  //         "partner_fun": "BP"
  //       },
  //       {
  //         "id": "a9484b15-1640-4b52-8f0d-8542bdb394d6",
  //         "name": "Gobind Tyres",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "LAMINGTON ROAD, NR.MINERVA",
  //         "address2": null,
  //         "city": "Mumbai",
  //         "state": null,
  //         "zip": "400007",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:33.463Z",
  //         "updated_at": "2023-10-31T08:18:33.463Z",
  //         "country": "IN",
  //         "sap_id": "11000011",
  //         "sap_ref": "24219",
  //         "kunn2": "11000011",
  //         "partner_fun": "SH"
  //       },
  //       {
  //         "id": "7744c08c-baeb-40de-a85a-8ea4c3e4e938",
  //         "name": "Gobind Tyres",
  //         "first_name": null,
  //         "last_name": null,
  //         "address1": "LAMINGTON ROAD, NR.MINERVA",
  //         "address2": null,
  //         "city": "Mumbai",
  //         "state": null,
  //         "zip": "400007",
  //         "phone": null,
  //         "customer_id": null,
  //         "created_at": "2023-10-31T08:18:33.463Z",
  //         "updated_at": "2023-10-31T08:18:33.463Z",
  //         "country": "IN",
  //         "sap_id": "11000011",
  //         "sap_ref": "24219",
  //         "kunn2": "11000011",
  //         "partner_fun": "SP"
  //       }
  //     ],
  //     "total_alerts": 0,
  //     "dashboard": [
  //       {
  //         "ShipStatus0": "",
  //         "CompletedQuotation": "1",
  //         "ShipStatus1": "",
  //         "OpenQuotation": "2",
  //         "ShipStatus2": "",
  //         "CompletedSales": "",
  //         "ShipStatus3": "",
  //         "OpenSales": "2",
  //         "ShipStatus4": "",
  //         "CompletedDelivery": "",
  //         "ShipStatus5": "",
  //         "OpenDelivery": "",
  //         "ShipStatus6": "",
  //         "CompletedBilling": "",
  //         "ShipStatus7": "",
  //         "OpenBilling": ""
  //       }
  //     ]
  //   }
  // ])


  // console.log(customers);
  return (
    <div className="profile-menu">
      <span className="close">
        <img
          src={close}
          style={{ width: "1rem", height: "1rem" }}
          alt="close"
          onClick={() => {
            setOpen(false);
          }}
        />
      </span>
      <div className="user">
        <span className="img">
          <img src={user} alt="user" />
        </span>
        <p>{email || displayEmail}</p>
        {/* {customers?.length ?
          <p className="mt1 mb1">
            Switch To: <Select
              options={customers?.map(ele => ({ label: ele.name, value: ele.id }))}
              placeholder={"Select Customer"}
              onChange={(val) => {

              }}
              dropdownStyle={{
                zIndex: 10000
              }}
            />
          </p> : null} */}
        <div className="flex-center logout">
          {canManageDelegates && (
          <button onClick={() => history.push("/delegate-user-roles")}
            >
            Manage Delegates
          </button>
          )}
        <button
            onClick={() => {
              setOpen(false);
              const email = localStorage.getItem("email");
              dispatch(logout({ email }));
              setTimeout(() => {
              localStorage.clear();
              toast.success("Successfully logged out");
              history.push("/");
            }, 1000);
            }}
          >
            Logout
          </button>
        </div>
      </div>
      <br />
      <h4>Help and Support</h4>
      <ul>
        <li className="cursor" onClick={() => {
          window.open("https://www.omni-united.com/contact-us", "_blank")
        }}>Contact Us</li>
      </ul>
    </div>
  );
};

export default ProfileMenu;
